import React from "react";
import { DownloadCloud } from "lucide-react";
import { Button } from "./ui/button";

// Full-viewport replacement for the routed app content — rendered by
// ForceUpdateGate (App.js) whenever the installed native app's version is
// below the tenant's configured minimum for this platform + persona.
// Mirrors NoInternetScreen's structure; unlike offline, there's no
// background retry — the only way out is installing the update.
export default function ForceUpdateScreen({ storeUrl, appName }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-cream px-5" data-testid="force-update-screen">
      <div className="bg-white rounded-3xl border border-neutral-200 p-8 text-center max-w-md w-full">
        <div className="w-16 h-16 rounded-3xl bg-brand-sky/10 text-brand-sky flex items-center justify-center mx-auto">
          <DownloadCloud className="w-8 h-8" strokeWidth={2.2} />
        </div>
        <h2 className="font-heading text-2xl font-extrabold mt-5">Update Required</h2>
        <p className="text-neutral-600 mt-2 leading-relaxed">
          A newer version of {appName || "this app"} is required to continue. Please update to keep using it.
        </p>
        {storeUrl ? (
          <a href={storeUrl} target="_blank" rel="noreferrer" data-testid="force-update-btn">
            <Button className="mt-6 h-14 rounded-2xl bg-brand-sky hover:bg-blue-700 font-bold px-7 w-full">
              Update Now
            </Button>
          </a>
        ) : (
          <p className="mt-6 text-sm text-neutral-500">
            Please check the app store for an available update.
          </p>
        )}
      </div>
    </div>
  );
}
